import { useMemo } from "react";
import { getStorageUsage } from "../../lib/manifest";
import { ev, evMsg } from "../../lib/everythingCopy";
import { formatBytes } from "./FileTile";

export function ManifestQuota({ files }) {
  const storage = useMemo(() => getStorageUsage(files), [files]);

  const barColor = storage.isFull
    ? "bg-red-500"
    : storage.isCritical
      ? "bg-amber-500"
      : storage.isWarning
        ? "bg-zinc-500"
        : "bg-zinc-300 dark:bg-zinc-500";

  const tooltip = evMsg(ev.storageTooltip, {
    used: formatBytes(storage.used),
    limit: formatBytes(storage.limit),
    remaining: formatBytes(storage.remaining),
  });

  return (
    <div className="flex flex-col items-end gap-1 shrink-0" title={tooltip}>
      <span className="text-[10px] leading-none text-zinc-400 dark:text-zinc-500 tabular-nums whitespace-nowrap">
        {evMsg(ev.storageLabel, {
          used: formatBytes(storage.used),
          limit: formatBytes(storage.limit),
          pct: Math.round(storage.pct),
        })}
      </span>
      <div className="w-[88px] h-1 rounded-full bg-zinc-100 dark:bg-zinc-800 overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-300 ${barColor}`}
          style={{ width: `${Math.max(storage.pct, storage.used > 0 ? 1 : 0)}%` }}
        />
      </div>
    </div>
  );
}
